export default __webpack_public_path__ + "static/media/img-bug-bounty-banner.3efbd300.png";